<template>
  <div class="menuSettingWrapper">
    <AppDeliveryTargetSetting
      :menu-setting="menuSetting"
      :disabled="readonly"
    />
    <AdvancedSetting
      v-if="isVisitorSelected"
      @toggle="onToggle"
      button-text="詳細設定"
      class="mb-3"
    >
      <AppDeliveryTargetAdvancedSetting
        :campaign="deliverySetting"
        :disabled="readonly"
      />
    </AdvancedSetting>
  </div>
</template>

<script>
import AppDeliveryTargetSetting from '@/components/App/AppDeliveryTargetSetting'
import AppDeliveryTargetAdvancedSetting from '@/components/App/AppDeliveryTargetAdvancedSetting'
import { MenuTargets } from '@/models/CampaignOperation'
import AdvancedSetting from '@/components/Shared/CrudUI/AdvancedSetting'
export default {
  name: 'SimulationContentDeliveryContentDeliveryTargetSetting',
  components: {
    AppDeliveryTargetAdvancedSetting,
    AppDeliveryTargetSetting,
    AdvancedSetting,
  },
  props: {
    deliverySetting: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    menuSetting() {
      return this.deliverySetting.menuSetting
    },
    isVisitorSelected() {
      return this.menuSetting.targetCode.includes(MenuTargets.VISITOR)
    },
  },
  methods: {
    onToggle(isOpen) {
      this.$emit('toggleDisplayState', isOpen)
    },
  },
}
</script>

<style scoped>
.menuSettingWrapper {
  padding: 20px;
}
</style>
